import React, { useEffect, useState } from "react";
import { Btn } from "../../../AbstractElements";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/Dropdown";

import {
  useAddProduct,
  useBrandList,
  useCategoryList,
  usePackageList,
  useSingleProduct,
  useTagList,
  useUpdateProduct,
} from "../hooks/useProductCatalogue";
// import { useGetOrgUnitsData } from "../../Employee/hooks/useEmployee";
import RouteDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { useGetOrgUnitsData } from "../../Configuration/Grade Master/hooks/useGradeMaster";
import { getBrandData } from "../hooks/ProductRepository";
import PaginatedRouteDropdown from "../../../Component/BasicComponents/Dropdowns/PaginatedDropdownWrapper";
import { showToast } from "../../../utils/toastUtils";
import { Spinner } from "reactstrap";

const ProductModalContent = ({
  mode,
  selectedBrand,
  setSelectedBrand,
  handleSubmitp,
  handleClose,
  ProductID,
}: any) => {
  console.log(
    "🚀 ~ ProductModalContent.tsx:29 ~ selectedBrand:",
    selectedBrand
  );

  const [modalReady, setModalReady] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);



  const getEmptyProduct = () => ({
  ProductName: "",
  ProductDescription: "",
  PackingQty: "",
  PackingDesc: "",
  ProductSku: "",
  BasePrice: "",
  orgUnits: "",
  Brand: null,
  Category: "",
  Tag: "",
  PackingType: "",
});

  const getProductData = useSingleProduct({
    id: ProductID,
    enable: !!ProductID, // Only enable if id is defined
  });

  console.log("Product Id", getProductData);
  const { data: orgUnitsList ,isLoading:isOrgUnitsLoading } = useGetOrgUnitsData({
    enable: true,
  });


  //  console.log('selectedBrand.PackingType::',selectedBrand.PackingType); // o/p g
  // const { data: BrandList } = useBrandList({
  //   params: {
  //     Orgunitid: selectedBrand?.orgUnits,
  //   },
  //   enable: !!selectedBrand?.orgUnits,
  // });

  const { data: CategoryList,isLoading:isCategoryLoading  } = useCategoryList({
    params: {
      orgUnitId: selectedBrand?.orgUnits,
    },
    enable: !!selectedBrand?.orgUnits,
  });

  const { data: TagList,isLoading:isTagLoading  } = useTagList({
    enable: !!selectedBrand?.orgUnits,
  });

  const { data: PackingList ,isLoading:isPackingLoading } = usePackageList({
    enable: !!selectedBrand?.orgUnits,
  });

  const FormattedDataorgunit =
    Object.entries(orgUnitsList?.data || {}).map((item: any) => ({
      id: item[0],
      label: item[1],
    })) || [];

  // const brandsFormattedData =
  //   (BrandList?.data?.data || []).map((item: any, index: any) => ({
  //     id: item?.BrandId,
  //     label: item?.BrandName,
  //   })) || [];

  const categoryFormattedData =
    (CategoryList?.data?.data || []).map((item: any, index: any) => ({
      id: item?.Id,
      label: item?.CategoryName,
    })) || [];

  const tagFormattedData =
    (TagList?.data?.data || []).map((item: any, index: any) => ({
      id: item?.Id,
      label: item?.TagName,
    })) || [];

  const packingFormattedData =
    (PackingList?.data?.data || []).map((item: any, index: any) => ({
      id: item?.UnitId,
      label: item?.UnitCode,
    })) || [];

  useEffect(() => {
    if (mode === "add") {
    setSelectedBrand(getEmptyProduct());
    setModalReady(true);
  }

    if (getProductData?.data?.data) {
      setSelectedBrand({
        ProductName: getProductData.data.data.ProductName || "",
        ProductDescription: getProductData.data.data.ProductDescription || "",
        PackingQty: getProductData.data.data.PackingQty || "",
        PackingDesc: getProductData.data.data.PackingDesc || "",
        ProductSku: getProductData.data.data.ProductSku || "",
        BasePrice: getProductData.data.data.BasePrice || "",
        orgUnits: getProductData.data.data.OrgunitId || "",
        Brand:
          getProductData.data.data.BrandId && getProductData.data.data.BrandName
            ? {
                id: getProductData.data.data.BrandId,
                label: getProductData.data.data.BrandName,
              }
            : null,
        Category: getProductData?.data?.data.categoryId || "",
        Tag: getProductData?.data?.data.TagId || "",
        // PackingType: getProductData?.data?.data.PackingDesc || "",
        PackingType: getProductData?.data?.data.UnitD || "",
      });
      setModalReady(true);
    }
  }, [getProductData?.data,mode,ProductID]);

  
  const handleDropdownSelect = (
    field: string,
    value: string | number | string[] | number[]
  ) => {
    setSelectedBrand((prevState: any) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const { mutate: addProduct } = useAddProduct();
  const { mutate: updateProduct } = useUpdateProduct();

  const handleLocalSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (isSubmitting) return;

     if (!selectedBrand?.orgUnits) {
    showToast.warning("Org Unit is required");
    return;
  }
  if (!selectedBrand?.Brand?.id) {
    showToast.warning("Brand is required");
    return;
  }
  if (!selectedBrand?.Category) {
    showToast.warning("Category is required");
    return;
  }
  if (!selectedBrand?.ProductName?.trim()) {
    showToast.warning("Product Name is required");
    return;
  }
  if (!selectedBrand?.ProductDescription?.trim()) {
    showToast.warning("Product Description is required");
    return;
  }
  if (!selectedBrand?.PackingQty) {
    showToast.warning("Packing Quantity is required");
    return;
  }
  if (Number(selectedBrand?.PackingQty) <= 0) {
    showToast.warning("Packing Quantity must be greater than 0");
    return;
  }
  if (!selectedBrand?.PackingDesc?.trim()) {
    showToast.warning("Packing Note is required");
    return;
  }
  if (!selectedBrand?.ProductSku?.trim()) {
    showToast.warning("SKU is required");
    return;
  }

    const payload: any = {
      OrgunitId: selectedBrand.orgUnits,
      BrandId: selectedBrand.Brand.id,
      CategoryId: selectedBrand.Category,
      ProductName: selectedBrand.ProductName,
      ProductDescription: selectedBrand.ProductDescription,
      UnitD: selectedBrand.PackingType,
      TagId: selectedBrand.Tag,
      PackingQty: selectedBrand.PackingQty,
      PackingDesc: selectedBrand.PackingDesc,
      ProductSku: selectedBrand.ProductSku,
      BasePrice: selectedBrand.BasePrice,
    };

    if (mode === "edit") {
      updateProduct(
        { reqBody: payload, id: ProductID },
        {
          onSuccess: () => {
            handleClose();
            setSelectedBrand(null);
          },
          onSettled: () => {
            handleClose();
            setSelectedBrand(null);
          },
          onError: (err) => {
            console.error(err);
          },
        }
      );
    } else {
      addProduct(payload, {
        onSuccess: () => {
          handleClose();
          setSelectedBrand(null);
        },
        onSettled: () => {
          handleClose();
          setSelectedBrand(null);
        },
        onError: (err) => {
          console.error(err);
        },
      });
    }
  };


  const isLoading =
  mode==="add"?isOrgUnitsLoading:
  (!modalReady || isOrgUnitsLoading || isCategoryLoading || isTagLoading || isPackingLoading )
  return (
    <>
    {isLoading?
    (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "60vh" }}
            >
              <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
              {/* <span className="ms-3">Loading SGPI Brands...</span> */}
            </div>
          ):(
    <form onSubmit={handleLocalSubmit}>
      {/* Second: Two Dropdowns in the Same Row */}
      <div className="row mb-3">
        <div className="col-md-4">
          <RouteDropdown
            DropdownHeading="Org Unit*"
            value={selectedBrand.orgUnits || []}
            onChange={(value: any) => {
              handleDropdownSelect("orgUnits", value);
            }}
            options={FormattedDataorgunit || []}
          />
        </div>
        <div className="col-md-4">
          <PaginatedRouteDropdown
          // key={selectedBrand.orgUnits}
          dependencies={[selectedBrand.orgUnits]}
            DropdownHeading="Brand*"
            onChange={(value: any) => {
              handleDropdownSelect("Brand", value);
            }}
            initialSelectedOptions={selectedBrand?.Brand}
            // options={brandsFormattedData || []}
            fetchOptions={async (page: any, search: any) => {
              const res = await getBrandData({
                page,
                limit: 10,
                search: search || "",
                Orgunitid: selectedBrand?.orgUnits,
              });
              return (res?.data?.data || []).map((key: any) => ({
                id: key.BrandId,
                label: key.BrandName,
              }));
            }}
          />
        </div>
        <div className="col-md-4">
          <RouteDropdown
            DropdownHeading="Category*"
            value={selectedBrand.Category}
            options={categoryFormattedData || []}
            onChange={(value: any) => {
              handleDropdownSelect("Category", value);
            }}
          />
        </div>
      </div>

      {/* One Input Field */}
      <div className="row mb-3">
        <div className="col-md-6">
          <label style={{ fontWeight: "500" }}>Product Name*</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter product name"
            value={selectedBrand?.ProductName || ""}
            onChange={(e) =>
              setSelectedBrand({
                ...selectedBrand,
                ProductName: e.target.value,
              })
            }
            style={{
              border: "2px solid #EDEDED",
              borderRadius: "8px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>
        <div className="col-md-6">
          <label style={{ fontWeight: "500" }}>Product Description*</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter product description"
            value={selectedBrand?.ProductDescription || ""}
            onChange={(e) =>
              setSelectedBrand({
                ...selectedBrand,
                ProductDescription: e.target.value,
              })
            }
            style={{
              border: "2px solid #EDEDED",
              borderRadius: "8px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>
      </div>

      {/* Two Dropdowns in the Same Row */}
      <div className="row mb-3">
        <div className="col-md-6">
          <RouteDropdown
            DropdownHeading="Packing Type"
            value={selectedBrand.PackingType || []}
            onChange={(value: any) => {
              handleDropdownSelect("PackingType", value);
            }}
            options={packingFormattedData || []}
          />
        </div>
        <div className="col-md-6">
          <RouteDropdown
            DropdownHeading="Tag"
            value={selectedBrand.Tag || []}
            onChange={(value: any) => {
              handleDropdownSelect("Tag", value);
            }}
            options={tagFormattedData || []}
          />
        </div>
      </div>

      {/* Two Inputs in the Same Row */}
      <div className="row mb-3">
        <div className="col-md-6">
          <label className="required-label">
            Packing Qty* 
          </label>
          <input
    type="number"
    className="form-control"
    placeholder="Enter packing qty"
    value={selectedBrand?.PackingQty || ""}
    onChange={(e) =>
      setSelectedBrand({
        ...selectedBrand,
        PackingQty: e.target.value,
      })
    }
    min={0}
    onKeyDown={(e) => {
    if (e.key === "-" || e.key === "e") {
      e.preventDefault(); // ⛔ block negative and exponential input
    }
  }}
    onWheel={(e) => e.currentTarget.blur()} // ⛔ prevent scroll increment/decrement
    style={{
      border: "2px solid #EDEDED",
      borderRadius: "8px",
      padding: "13px",
      fontSize: "14px",
      width: "100%",
    }}
  />
        </div>

        <div className="col-md-6">
          <label className="required-label">
            Packing Note*
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter packing note"
            value={selectedBrand?.PackingDesc || ""}
            onChange={(e) =>
              setSelectedBrand({
                ...selectedBrand,
                PackingDesc: e.target.value,
              })
            }
            style={{
              border: "2px solid #EDEDED",
              borderRadius: "8px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>
      </div>

      {/* Another Two Inputs in the Same Row */}
      <div className="row mb-3">
        <div className="col-md-6">
          <label style={{ fontWeight: "500" }}>
            SKU*
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter sku"
            value={selectedBrand.ProductSku || ""}
            onChange={(e) =>
              setSelectedBrand({
                ...selectedBrand,
                ProductSku: e.target.value,
              })
            }
            style={{
              border: "2px solid #EDEDED",
              borderRadius: "8px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>
        <div className="col-md-6">
          <label style={{ fontWeight: "500" }}>
            Base Price*
          </label>
         <input
  type="number"
  className="form-control"
  placeholder="Enter base price"
  value={selectedBrand?.BasePrice || ""}
  onChange={(e) =>
    setSelectedBrand({
      ...selectedBrand,
      BasePrice: e.target.value,
    })
  }
  onKeyDown={(e) => {
    if (e.key === "-" || e.key === "e") {
      e.preventDefault(); 
    }
  }}
  onWheel={(e) => e.currentTarget.blur()} 
  style={{
    border: "2px solid #EDEDED",
    borderRadius: "8px",
    padding: "13px",
    fontSize: "14px",
    width: "100%",
  }}
  min={0}
/>
        </div>
      </div>

      {/* Buttons */}
      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
  style={{ backgroundColor: "#43B9B2", color: "white" }}
  type="submit"
  disabled={isSubmitting} // ✅ Disable while submitting
>
  {isSubmitting ? "Submitting..." : mode !== "add" ? "Update Brand" : "Submit"}
</Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={handleClose}
        >
          Cancel
        </Btn>
      </div>
    </form>
        )
      }
      </>
  );
};

export default ProductModalContent;
